import { APIK_BASE_URL } from '~/constants/endpoints';

export const FeedItemType = {
  RETAIL_PURCHASE_IN_PROGRESS: 'RetailPurchaseInProgressLockActive',
  TRADE_PURCHASE_IN_PROGRESS: 'TradeInPurchaseInProgressLockActive',
  RETAIL_ORDER_PLACED: 'RetailPurchaseOrderPlaced',
  TRADE_ORDER_PLACED: 'TradeInPurchaseOrderPlaced',
  RETAIL_PREORDER: 'RetailPurchasePreOrder',
  POPULAR_MODELS_PROMO: 'PurchasePromoPopularModels',
  PURCHASE_POST_DELIVERY_0_7: 'PurchaseWithinSevenDayGuarantee',
  PURCHASE_POST_DELIVERY_8_100: 'SalePostSevenDayGuarantee',
  CARVANA_FINANCING_ACTIVE_OFFER: 'CarvanaFinancingActiveOffer',
  CARVANA_FINANCING_EXPIRED_OFFER: 'CarvanaFinancingExpiredOffer',
  PURCHASE_PROMO_AFFORDABLE: 'PurchasePromoAffordable',
  PURCHASE_PROMO_BODY_TYPE: 'PurchasePromoBodyType',
  PROMO_INSURANCE: 'CarvanaInsurancePromo',
  PROMO_FINANCING: 'CarvanaFinancingPromo',
  PROMO_SELL_TRADE: 'SellToCarvanaPromo',
  RETAIL_VIEWED_VEHICLES: 'RetailVehicleViewed',
  RETAIL_RECOMMENDED_VEHICLES: 'RetailRecommendedVehicles',
  PROMO_CVT: 'CarvanaValueTrackerPromo'
};

export const CAROUSEL_CARDS = [
  FeedItemType.POPULAR_MODELS_PROMO,
  FeedItemType.PURCHASE_PROMO_AFFORDABLE,
  FeedItemType.PURCHASE_PROMO_BODY_TYPE,
  FeedItemType.RETAIL_VIEWED_VEHICLES,
  FeedItemType.RETAIL_RECOMMENDED_VEHICLES
];

export const OFFER_CARDS = [
  FeedItemType.TRADE_ORDER_PLACED,
  FeedItemType.TRADE_PURCHASE_IN_PROGRESS,
  FeedItemType.RETAIL_ORDER_PLACED,
  FeedItemType.RETAIL_PURCHASE_IN_PROGRESS,
  FeedItemType.RETAIL_PREORDER,
  FeedItemType.PURCHASE_POST_DELIVERY_0_7
];

export const CONDENSED_CARDS = [
  FeedItemType.PROMO_FINANCING,
  FeedItemType.PROMO_SELL_TRADE
];

export const NBA_RECENT_VEHICLES_URL = `${APIK_BASE_URL}/home/homeapi/api/v1/unauth/homefeed/recentvdpviews`;

export const NBA_AUTH_BFF_FEED_URL = `${APIK_BASE_URL}/home/homeapi/api/v2/homefeed`;
export const NBA_UNAUTH_BFF_FEED_URL = `${APIK_BASE_URL}/home/homeapi/api/v2/unauth/homefeed`;
